// main.js
import { createApp } from 'vue'
import { createPinia } from 'pinia'
import axios from 'axios'
import App from './App.vue'

/**
 * Attach Microsoft Clarity session id to every request hitting our backend,
 * so backend logs (Grafana) can be correlated with a Clarity session replay.
 *
 * Covers all add-to-cart paths (old StepNavigstion + new imprint flow),
 * artwork uploads and any future backend call — one place, can't be missed.
 *
 * Excludes /apps/studio: that endpoint uses a restrictive CORS allow-list
 * (AllowStoreCors) that would reject a custom header on preflight.
 * Never throws — analytics must not break a checkout request.
 */
const CLARITY_BACKEND_HOST = 'api-customapp.comda.com';
function readClaritySessionId() {
    try {
        const cookie = document.cookie.split('; ').find(c => c.startsWith('_clsk='));
        if (!cookie) return null;
        return decodeURIComponent(cookie.split('=')[1]).split('^')[0] || null;
    } catch (e) {
        return null;
    }
}
axios.interceptors.request.use((config) => {
    try {
        const url = config.url || '';
        const isOurBackend = url.indexOf(CLARITY_BACKEND_HOST) !== -1;
        const isStudio = url.indexOf('/apps/studio') !== -1;
        if (isOurBackend && !isStudio) {
            const clarityId = readClaritySessionId();
            if (clarityId) {
                config.headers = config.headers || {};
                config.headers['X-Clarity-Session-Id'] = clarityId;
            }
        }
    } catch (e) {
        // swallow — never block a request because of analytics tagging
    }
    return config;
});
import './styles/main.scss'
import customStyles from './helpers/customStyles';
import ErrorModal from './components/ErrorModal.vue';
import { store } from './components/store';
import { PERSIST_KEYS } from './helpers/persistKeys';
import LoggerPlugin from '@/services/logPlugin/vueComponentLoggerPlugin';
import {StorageLogger} from "@/services/logPlugin/localStoragePlugin";
import {mockData} from '../public/mock-data/theme_settings';
import {useMockData} from "../public/mock-data/products";
import { initializeTheme } from './features/imprint/utils/custom_varaibles/themeInitializer';

// Setup logger console API (development only)
if (LoggerPlugin.isEnabled()) {
    window.$vueLogs = {
        print() {
            console.group('📜 Vue Components Logs')
            StorageLogger.render()
            console.groupEnd()
        },
        clear() {
            StorageLogger.clear()
        },
        filterByComponent(name) {
            console.group(`📜 Component "${name}" Logs`);
            StorageLogger.filterByComponent(name)
            console.groupEnd()
        },
        enable() {
            StorageLogger.enable()
        },
        disable() {
            StorageLogger.disable()
        }
    }
}


// Setup mock data from theme (locally only)
if (!window.PXUTheme && useMockData()) {
    window.PXUTheme = mockData.theme_settings;
    window.Shopify = mockData.Shopify;
}

    initializeTheme();
    // --- deep-merge with type checking
    function isPlainObject(v){ return Object.prototype.toString.call(v)==='[object Object]' }
    function safeMerge(target, source, depth = 0){
        console.warn("safeMerge begin", source);
        console.warn("safeMerge is plain object", !isPlainObject(source));
        if(!isPlainObject(target)||!isPlainObject(source)) return target;
        console.warn("safeMerge after first if", source);
        for(const k of Object.keys(source)){
           ////////// if(!(k in target)) continue; // ігноруємо невідомі ключі
            // whitelist – лише на верхньому рівні
            if(depth === 0 && !(k in target)) continue;


            const sv = source[k], tv = target[k];
            if(k == 'selectedLastStep') {
                console.warn("safeMerge if(depth === 0 && !(k in target)) continue;",  k);
                console.warn("safeMerge const sv = source[k], tv = target[k]",  sv);
                console.warn("safeMerge tvtvtv  Array.isArray(tv)",  Array.isArray(tv));
                console.warn("safeMerge svsvsv Array.isArray(sv)",  Array.isArray(sv));
                console.warn("safeMerge tvtvtv isPlainObject(tv)",  isPlainObject(tv));
                console.warn("safeMerge svsvsv isPlainObject(tv)",  isPlainObject(sv));
            }
            // ✅ Нове: якщо у таргеті ще нема цього піддерева — просто беремо з LS
            if (tv === undefined) {
              target[k] = sv;
              continue;
            }

            if (Array.isArray(tv)) {
                // Якщо у сховищі масив, а з LS прийшов або масив, або об'єкт-словник — приймаємо його
                if (Array.isArray(sv) || isPlainObject(sv)) {
                    target[k] = sv;
                    if(k == 'selectedLastStep') {
                        console.warn("safeMerge  target[k] = sv;", sv);
                    }
                } else {
                    target[k] = tv;
                    if(k == 'selectedLastStep') {
                        console.warn("safeMerge target[k] = tv;", sv);
                    }
                }
            } else if (isPlainObject(tv)) {
                // на вкладених рівнях дозволяємо додавати нові поля
                if(k == 'selectedLastStep') {
                    console.warn("safeMerge 1111 tv",  tv);
                    console.warn("safeMerge 1111 { ...tv }",  { ...tv });
                    console.warn("safeMerge 1111 const sv = source[k], tv = target[k]",  isPlainObject(sv));
                }
                target[k] = safeMerge({ ...tv }, isPlainObject(sv) ? sv : {}, depth + 1);
            } else if (typeof tv === 'number') {
                const n = typeof sv === 'number' ? sv : (typeof sv === 'string' ? Number(sv) : NaN);
                target[k] = Number.isFinite(n) ? n : tv;
            } else if (typeof tv === 'string') {
                target[k] = typeof sv === 'string' ? sv : tv;
            } else if (typeof tv === 'boolean') {
                target[k] = typeof sv === 'boolean' ? sv : tv;
            }
        }
        // ПІСЛЯ мерджу: що реально стало в store
        console.log('[Persist][MERGE][after]',
            'store.selectedLastStep=', target.selectedLastStep,
            'type=', typeof target.selectedLastStep,
            'store.colorSizeLines.type=', Array.isArray(target.colorSizeLines) ? 'array' : typeof target.colorSizeLines,
            'store.colorSizeLines.len=', Array.isArray(target.colorSizeLines) ? target.colorSizeLines.length : 'n/a'
        );
        return target;
    }
/**
    function normalizeTypes(s){
        // приклади найкритичніших полів
        if(!Array.isArray(s?.specialPrice?.tier)) s.specialPrice.tier = [];
        if(!Array.isArray(s?.colorSizeLines)) s.colorSizeLines = [];
        if(!Array.isArray(s?.selectedColorsList)) s.selectedColorsList = [];
        if(!Array.isArray(s?.availableColorsList)) s.availableColorsList = [];
        if(!Array.isArray(s?.imprintMessageColorLines)) s.imprintMessageColorLines = [];
        if(!Array.isArray(s?.calendar?.productList)) s.calendar.productList = [];

        s.prices.running_fee   = Number(s?.prices?.running_fee)   || 0;
        s.runningFeePerItem    = Number(s?.runningFeePerItem)     || 0;
        // додай тут інші числові поля, якщо Summary їх використовує
    }
**/

// debug helpers
function _typeOf(v){ return Array.isArray(v)? 'array' : (v===null? 'null' : typeof v); }
function _shape(obj){
      const out = {};
      for (const k of Object.keys(obj||{})) {
            const v = obj[k];
            out[k] = {
                  type: _typeOf(v),
                  sizeHint: Array.isArray(v) ? v.length :
                            (v && typeof v==='object') ? Object.keys(v).length :
                                (typeof v==='string' ? v.length : '')
                    };
      }
      return out;
    }

    (function hydrate(){
        const LS_KEY = 'imprintUserDataV1';
        try {
            const raw = localStorage.getItem(LS_KEY);
            if (!raw) return;

            const parsed = JSON.parse(raw);
            if (!isPlainObject(parsed)) return;

            // зріз лише дозволених ключів
            const slice = {};
            for (const k of PERSIST_KEYS) if (k in parsed) slice[k] = parsed[k];
            // 🧪 детальні логи станів до merge
            console.groupCollapsed('🧪 [Hydrate] LS parsed (full) shape');
            console.table(_shape(parsed));
            console.groupEnd();

            console.groupCollapsed('🧪 [Hydrate] whitelist slice shape');
            console.table(_shape(slice));
            console.log('slice raw:', slice);
            console.groupEnd();

            console.groupCollapsed('🧪 [Hydrate] store BEFORE merge shape');
            console.table(_shape(store));
            console.groupEnd();
            console.log('🧪 Hydrate check key presence:',
                'selectedLastStep' in store, store.selectedLastStep);
            safeMerge(store, slice);
            console.groupCollapsed('🧪 [Hydrate] store AFTER merge shape');
            console.table(_shape(store));
            console.log('store raw:', store);
            console.groupEnd();

            // ⬇️ залишаємо закоментованим під тест
            // normalizeTypes(store);
            // localStorage.removeItem(LS_KEY);
            console.log('♻️ [Vue Imprint] Restored user data (safe whitelist merge)');
            console.log('♻️ [Vue Imprint] Store data', store);
        } catch (e) {
            console.warn('[Vue Imprint] Restore failed:', e);
        }
    })();

function mountVue() {
    const targetSel = '#section-image-with-text-c';
    const target = document.querySelector(targetSel);

    if (!target) {
        console.warn('[Vue Imprint] Mount target not found:', targetSel, 'readyState=', document.readyState);
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', mountVue, { once: true });
        } else {
            setTimeout(mountVue, 200); // секція може приїхати пізніше з liquid
        }
        return;
    }

    const app = createApp(App);
    const pinia = createPinia();
    app.use(pinia);
    app.use(customStyles);
    app.component('ErrorModal', ErrorModal);
    app.use(LoggerPlugin);
    app.mount(targetSel);
    console.log('✅ [Vue Imprint] Vue mounted on', targetSel);

    window.__testErr = () => {
        window.dispatchEvent(new CustomEvent('add-to-cart-error', { detail: { message: 'Test from __testErr' } }));
    };
}
mountVue();